export function getPreorderPlan(variantId, stoq = globalThis._RestockRocket) {
  const plan = stoq?.getSellingPlan?.(Number(variantId));
  if (!plan?.enabled || plan.payment_type !== 'full' || !plan.variant_ids?.some(id => String(id) === String(variantId)) || !/^\d+$/.test(String(plan.shopify_selling_plan_id))) throw new Error('closed');
  return String(plan.shopify_selling_plan_id);
}

export async function addPreorder(offer, fetcher = globalThis.fetch) {
  if (!offer.enabled) throw new Error('closed');
  if (!Number.isSafeInteger(offer.quantity) || offer.quantity < 1) throw new Error('quantity');
  if ([offer.variantId, offer.sellingPlanId, offer.notebookVariantId, offer.notebookSellingPlanId].some(id => !/^\d+$/.test(String(id)))) throw new Error('closed');
  const added = await fetcher(offer.addUrl, {
    method: 'POST',
    credentials: 'same-origin',
    signal: AbortSignal.timeout(15000),
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [
      { id: offer.variantId, quantity: offer.quantity, selling_plan: offer.sellingPlanId },
      { id: offer.notebookVariantId, quantity: offer.quantity, selling_plan: offer.notebookSellingPlanId }
    ] })
  });
  if (!added.ok) throw new Error('add');
  const result = await added.json();
  if (result.status || !Array.isArray(result.items) || !result.items.length) throw new Error('add');
  return result;
}

export async function addCharlotteChristmasPackage(offer, fetcher = globalThis.fetch) {
  if (!offer.enabled) throw new Error('closed');
  if (!Number.isSafeInteger(offer.quantity) || ![1, 2].includes(offer.quantity)) throw new Error('quantity');
  const ids = [offer.charlotteBook, offer.charlottePlan, offer.notebook, offer.notebookPlan, offer.christmasBook, offer.christmasPlan, offer.audiobook, offer.card, offer.cardPlan, offer.letters];
  if (ids.some(id => !/^\d+$/.test(String(id)))) throw new Error('closed');

  const added = await fetcher(offer.addUrl, {
    method: 'POST',
    credentials: 'same-origin',
    signal: AbortSignal.timeout(15000),
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [
      { id: offer.charlotteBook, quantity: offer.quantity, selling_plan: offer.charlottePlan },
      { id: offer.notebook, quantity: offer.quantity, selling_plan: offer.notebookPlan },
      { id: offer.christmasBook, quantity: 1, selling_plan: offer.christmasPlan },
      { id: offer.audiobook, quantity: 1 },
      { id: offer.card, quantity: 1, selling_plan: offer.cardPlan },
      { id: offer.letters, quantity: 1 }
    ] })
  });
  if (!added.ok) throw new Error('add');
  const result = await added.json();
  if (result.status || !Array.isArray(result.items) || result.items.length !== 6) throw new Error('add');
  return result;
}

if (globalThis.customElements && !customElements.get('charlotte-book-order')) {
  customElements.define('charlotte-book-order', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      if (!form) return;
      const button = form.querySelector('button[type="submit"]');
      const error = this.querySelector('[data-order-error]');
      button.disabled = this.dataset.enabled !== 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        error.textContent = '';
        try {
          await addPreorder({
            enabled: this.dataset.enabled === 'true',
            variantId: form.elements.id.value,
            sellingPlanId: getPreorderPlan(form.elements.id.value),
            notebookVariantId: this.dataset.notebookVariantId,
            notebookSellingPlanId: this.dataset.notebookSellingPlanId,
            quantity: Number(this.dataset.quantity),
            addUrl: this.dataset.addUrl
          });
          window.location.assign(this.dataset.destination);
        } catch (failure) {
          error.textContent = failure.message === 'closed' ? this.dataset.closedError : this.dataset.requestError;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    }
  });
}

if (globalThis.customElements && !customElements.get('charlotte-christmas-order')) {
  customElements.define('charlotte-christmas-order', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const button = this.querySelector('button');
      const error = this.querySelector('[data-order-error]');
      if (!button || !error) return;
      button.disabled = this.dataset.enabled !== 'true';
      button.addEventListener('click', async () => {
        if (button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        error.textContent = '';
        try {
          await addCharlotteChristmasPackage({
            enabled: this.dataset.enabled === 'true',
            quantity: Number(this.dataset.quantity),
            charlotteBook: this.dataset.charlotteBookId,
            charlottePlan: this.dataset.charlottePlanId,
            notebook: this.dataset.notebookId,
            notebookPlan: this.dataset.notebookPlanId,
            christmasBook: this.dataset.christmasBookId,
            christmasPlan: this.dataset.christmasPlanId,
            audiobook: this.dataset.audiobookId,
            card: this.dataset.cardId,
            cardPlan: this.dataset.cardPlanId,
            letters: this.dataset.lettersId,
            addUrl: this.dataset.addUrl
          });
          window.location.assign(this.dataset.destination);
        } catch (failure) {
          error.textContent = failure.message === 'closed' ? this.dataset.closedError : this.dataset.requestError;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    }
  });
}
